/**
 * Utility functions for project schedule calculations
 * Some functions are deprecated - use Project and Schedule classes directly
 */

import { Project } from "../models/Project";

/**
 * Format a date for use in date input fields
 * @param date - Date to format
 * @returns Formatted date string (YYYY-MM-DD)
 */
export const formatDateForInput = (date: Date | undefined): string => {
  if (!date) return "";
  const d = new Date(date);
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

/**
 * Parse a date string from date input field (YYYY-MM-DD) to a Date object
 * Creates date in local timezone to avoid off-by-one errors
 * @param dateString - Date string in YYYY-MM-DD format
 * @returns Date object in local timezone
 */
export const parseDateFromInput = (dateString: string): Date => {
  if (!dateString) return new Date();

  // Parse the string manually to avoid timezone issues
  const [year, month, day] = dateString.split("-").map(Number);

  // Month is 0-based in Date constructor, but 1-based in the input string
  return new Date(year, month - 1, day);
};

/**
 * Get the next available project ID
 * @param projects - Array of Project instances
 * @returns Next available ID
 */
export const getNextProjectId = (projects: Project[]): number => {
  if (!projects || projects.length === 0) return 1;
  const maxId = Math.max(...projects.map((p) => p.id || 0), 0);
  return maxId + 1;
};
